<template>
<div>
   <youtube :width="'100%'"  @ended="youtubeFinish" @error="errorYoutube" :height="680" :video-id="idVideo" ref="youtube" :player-vars="playerVars" @playing="playing"></youtube>
</div>
</template>

<script>

// import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'myYoutube',
  props: {
    idVideo: String,
    volume: Number,
    mystop: { type: Boolean, default: false },
    mystart: { type: Boolean, default: false }
  },

  computed: {
    player () {
      return this.$refs.youtube.player
    }
  },
  watch: {
    mystop (val) {
      if (val) {
        this.player.stopVideo()
        clearTimeout(this.timerDuracao)
      } else {
        this.player.playVideo()
        this.$emit('playYoutube')
        this.timerDuracao = setTimeout(() => {
          this.$emit('stop')
          this.player.playVideo()
        }, 65000)
      }
    },
    volume (val) {
      this.player.setVolume(val)
    }
  },
  data () {
    return {
      playerVars: {
        // altura
        timerDuracao: '',
        autoplay: 1,
        controls: 0,
        autohide: 1,
        showinfo: 1,
        loop: 1,
        muted: 0
      }
    }
  },
  methods: {
    youtubeFinish () {
      // console.log('status', status)
      this.$emit('stop')
    },
    errorYoutube () {
      if (this.idVideo) {
        // console.log('erro')
        this.$emit('youtubeError', this.idVideo)
      }
    },
    playVideo () {
      this.player.playVideo()
    },
    playing (val) {
      // console.log('plaing', val.getCurrentTime())
    }
  }
}
</script>

<style scoped>

</style>
